
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import useArenaSetting from '@/modules/arena/setting/model/edit';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';

export default defineComponent({
    name: ROUTE_NAME_ARENA.SETTING,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, fetch, actions } = useArenaSetting();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions };
    }
});
